export const CurveRouter = [
  'event Exchange(address indexed,address indexed,address[11],uint256[5][5],address[5],uint256,uint256)',
  'fallback()',
  'constructor(address,address,address,address[2])',
  'function exchange(address[11],uint256[5][5],uint256,uint256)',
  'function exchange(address[11] _route, uint256[5][5] _swap_params, uint256 _amount, uint256 _expected, address[5] pools, address _receiver)',
  'function exchange(address[11] _route, uint256[5][5] _swap_params, uint256 _amount, uint256 _expected, address[5] _pools)',
  'function get_dy(address[11],uint256[5][5],uint256)',
  'function get_dy(address[11],uint256[5][5],uint256,address[5])',
  'function get_dx(address[11],uint256[5][5],uint256,address[5])',
  'function get_dx(address[11],uint256[5][5],uint256,address[5],address[5])',
  'function get_dx(address[11],uint256[5][5],uint256,address[5],address[5],address[5])',
  'function get_dx(address[11],uint256[5][5],uint256,address[5],address[5],address[5],address[5])',
  'function get_dx(address[11],uint256[5][5],uint256,address[5],address[5],address[5],address[5],address[5])'
]
